import { useState, useEffect } from 'react';
import { getFeedbackStatuses } from 'services/clients/sites/siteApplications/feedbackStatuses';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { showError } from '../../../../../redux/common/actions';
import { getLocalStorageData } from 'helpers/utils';
import { SHOW_ALL_OPTION } from '../../constants';

export const useFeedbackStatuses = (showAll = true) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [feedbackStatuses, setFeedbackStatuses] = useState([]);
  const { siteAppID } = getLocalStorageData("me");

  useEffect(() => {
    const loadFeedbackStatuses = async () => {
      try {
        const response = await getFeedbackStatuses(siteAppID);
        if (response.status) {
          const fetchedStatuses = response.data.map((x) => {
            if (x.type === "C") return { ...x, groupBy: "Complete" };
            return { ...x, groupBy: "Outstanding" };
          });
          
          const processedStatuses = showAll 
            ? [SHOW_ALL_OPTION, ...fetchedStatuses]
            : fetchedStatuses;
          
          setFeedbackStatuses(processedStatuses);
        }
      } catch (error) {
        dispatch(
          showError(
            error?.response?.data?.detail || t('message.failedToFetchFeedbackStatuses')
          )
        );
      }
    };

    if (siteAppID) {
      loadFeedbackStatuses();
    }
  }, [siteAppID, showAll, dispatch, t]);

  return feedbackStatuses;
}; 
